import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
function Cases({ cases = [], fetchCases }) {

  if (!cases.length) {
    return <div>No project found.</div>;
  }

  return (
    <div className="space-y-4">
      {cases.map((caseItem) => (
        <div
          key={caseItem._id}
          className="flex flex-col md:flex-row items-start bg-white rounded-xl shadow-md border border-gray-200 p-4 gap-4"
        >
          <div className="flex-shrink-0 w-full md:w-1/4 h-24 bg-gray-100 rounded-lg flex items-center justify-center text-gray-400 text-sm">
            📄 project
          </div>

          <div className="flex-1">
            <Link to={`/clientcases/${caseItem._id}`}>
              <h2 className="text-xl font-semibold mb-1">
                {caseItem.caseTitle || 'Untitled Case'}
              </h2>
              <p className="text-gray-600 mb-1">
              <span className="font-medium">Client:</span> {caseItem.client?.clientName}
              </p>
              <p className="text-gray-600 mb-1">
                <span className="font-medium">Project Type:</span> {caseItem.caseType}
              </p>
              <p className="text-gray-600">
                <span className="font-medium">Hearing Date:</span> {caseItem.hearingDate}
              </p>
            </Link>
          </div>

         
        </div>
      ))}
    </div>
  );
}

export default Cases;
